export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const USE_MOCK_DATA = process.env.REACT_APP_USE_MOCK_DATA === "true";
// rivalz-games-services base URL (wallet launch/balance, lobby diagnostics).
export const GAME_SERVICE_API_BASE =
  process.env.REACT_APP_GAME_SERVICE_BASE_URL ||
  (window.location.hostname === "localhost"
    ? "http://localhost:3001"
    : window.location.origin);
export const API_CONSTANTS = {
  login: `${BASE_URL}/login`,
  register: `${BASE_URL}/register`,
  forgotPassword: `${BASE_URL}/forgot-password`,
  resetPassword: `${BASE_URL}/reset-password`,
  verifyEmail: `${BASE_URL}/verify-email`,
  resendVerificationEmail: `${BASE_URL}/resend-verification-email`,
  logout: `${BASE_URL}/logout`,
  appHomepage: `/app/homepage`,
  meta: `/meta`,
  result: "/reward/game-history/history",
  revealResult: "/reward/game-history/reveal",
  rewardMatchByRegistration: `/reward/game-history/match`,
  gameLobby: "/lobby",
  game: "/game",
  wallet: "/wallet",
};
